import { useRouteMatch, useLocation } from 'react-router-dom';
import { useFlags } from 'utils/react-context';

const SESSION_ROUTE = '/session/';

export default function useSessionsRoutes() {
    const { url } = useRouteMatch();
    const { search } = useLocation();
    const { zoomSdkObfTokenEnabled } = useFlags();
    const [baseUrl] = url.split(SESSION_ROUTE);
    const queryParams = new URLSearchParams(search);

    if (zoomSdkObfTokenEnabled) {
        queryParams.delete('code');
        queryParams.delete('meeting-id');
        queryParams.delete('session-id');
    }

    return {
        leaveSessionUrl: `${baseUrl}${queryParams.toString() ? `?${queryParams.toString()}` : ''}`,
        joinSessionUrl: `${baseUrl}${SESSION_ROUTE}`,
    };
}
